import { Flex } from 'antd';
import styles from './comment.module.scss';
import { calculateDateFromISOtoYYYY_MM_DD, calculateHourFromISODate } from '@/utils/helpers';
import { Avatar } from '../avatar/avatar';

interface CommentProps {
  name: string;
  text: string;
  date: string;
  withSeparator?: boolean;
}

export function Comment({ text, date, name, withSeparator = true }: CommentProps) {
  return (
    <Flex className={styles.commentContainer}>
      <Avatar />
      <Flex gap={15} vertical flex={1}>
        <Flex gap={15} align="center">
          <p className={styles.name}>{name}</p>
          <Flex wrap="wrap">
            <p className={styles.date}>{calculateDateFromISOtoYYYY_MM_DD(date)}</p>
            <span className={styles.circle}>&#9679;</span>
            <p className={styles.hour}>{calculateHourFromISODate(date)}</p>
          </Flex>
        </Flex>
        <p className={styles.comment}>{text}</p>
        {withSeparator && <hr className={styles.separator} />}
      </Flex>
    </Flex>
  );
}
